// components/NotFound.js
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const NotFound = () => {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center bg-black text-white min-vh-100 text-center px-3" style={{ backgroundImage: 'url(https://www.hearthcards.net/images/bg_new.jpg)', backgroundPosition: 'center center' }}>
      <h1 className="display-4 mb-4">Page Not Found</h1>
      <img 
        src="/images/ded-murloc.svg" 
        alt="404 Error" 
        className="img-fluid mb-4" 
        style={{ width: '90%', maxWidth: '512px' }}
      />
      <a href="/gallery/" className="btn btn-outline-light px-4 py-2">
        Back to Home
      </a>
    </div>
  );
};

export default NotFound;
